import { jsxs, jsx } from "react/jsx-runtime";
import { c as clsx } from "../../../../chunks/clsx-DF9QTL9H.js";
import { Icon } from "../../../../foundations/icons/Icon.js";
import { Text } from "../../../../foundations/typography/Text/Text.js";
import { useModalContext } from "./hooks/useModalContext.js";
import { s as styles } from "../../../../chunks/Modal.module-BNu8pxzB.js";
const ModalHeader = ({
  closeButtonDescription,
  children,
  headingLevel = "h1",
  ...props
}) => {
  const { isDismissable, onClose } = useModalContext();
  return /* @__PURE__ */ jsxs("header", { className: clsx(styles.modalHeader, props.className), ...props, children: [
    typeof children === "string" ? /* @__PURE__ */ jsx(Text, { component: headingLevel, variant: "heading-small", children }) : children,
    isDismissable && /* @__PURE__ */ jsx(
      "button",
      {
        className: styles.modalHeaderButton,
        onClick: onClose,
        "aria-label": closeButtonDescription,
        children: /* @__PURE__ */ jsx(Icon, { variant: "XBig", "aria-hidden": true })
      }
    )
  ] });
};
export {
  ModalHeader
};
